export default [
  {
    path: 'detectionRecord',
    name: 'firefightingBaleDetectionRecord',
    component: () => import('@/views/firefighting/detectionRecord/index.vue'),
    meta: {
      activeMenu: '/firefighting',
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'monitoringRecord',
    name: 'firefightingBaleMonitoringRecord',
    component: () => import('@/views/firefighting/monitoringRecord/index.vue'),
    meta: {
      activeMenu: '/firefighting',
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'alarmRecord',
    name: 'firefightingBaleAlarmRecord',
    component: () => import('@/views/firefighting/alarmRecord/index.vue'),
    meta: {
      activeMenu: '/firefighting',
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'dangerousGoodsInfo',
    name: 'firefightingDangerousGoodsInfo',
    component: () => import('@/views/firefighting/dangerousGoodsInfo/index.vue'),
    meta: {
      activeMenu: '/firefighting',
      hidden: true,
      noPadding: true
    }
  }
];
